// Define the names and colors for each SRS level

export const srsMapping = {
  0: 'Air',
  1: 'Wood',
  2: 'Vermillion',
  3: 'Silver',
  4: 'Gold',
  5: 'Diamond',
  6: 'Emerald',
  7: 'Titanium',
};

// Points assigned to each SRS stage — used to calculate pts gained/lost per review
export const srsPoints = {
  0: 0,
  1: 10,
  2: 25,
  3: 50,
  4: 100,
  5: 200,
  6: 350,
  7: 500,
};

// A mapping for JLPT levels for display purposes
export const levelMapping = {
  5: 'N5',
  4: 'N4',
  3: 'N3',
  2: 'N2',
  1: 'N1',
  0: 'N0 (Out of JLPT)',
};
